import { ProjectLayout } from "@/components/project-layout";
import { AgentsPage } from "@/pages/agents";
import { HardwarePage } from "@/pages/hardware";
import { HomePage } from "@/pages/home";
import { IssuesPage } from "@/pages/issues";
import { JobsPage } from "@/pages/jobs";
import { LandingPage } from "@/pages/landing";
import { LoginPage } from "@/pages/login";
import { McpPage } from "@/pages/mcp";
import { MilestonesPage } from "@/pages/milestones";
import { OrgPage } from "@/pages/org";
import { PrivacyPage } from "@/pages/privacy";
import { RegisterPage } from "@/pages/register";
import { RequirementsPage } from "@/pages/requirements";
import { ReviewsPage } from "@/pages/reviews";
import { InvitePage } from "@/pages/invite";
import { SettingsPage } from "@/pages/settings";
import { Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";

/** Honest redirect of a legacy project path onto the UnderlineNav tab, keeping id + search + hash. */
function ProjectLegacyRedirect({
  to,
  param,
}: {
  to: string;
  param?: string;
}) {
  const params = useParams();
  const location = useLocation();
  const extra = param && params[param] ? `/${params[param]}` : "";
  return (
    <Navigate
      to={`/o/${params.orgSlug}/p/${params.projectSlug}/${to}${extra}${location.search}${location.hash}`}
      replace
    />
  );
}

export function App() {
  return (
    <div className="min-h-0 flex-1 overflow-hidden">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/access" element={<LoginPage />} />
        <Route path="/invite" element={<InvitePage />} />
        <Route path="/o/:orgSlug" element={<OrgPage />} />
        <Route path="/o/:orgSlug/p/:projectSlug" element={<ProjectLayout />}>
          <Route index element={<HomePage />} />
          <Route path="files" element={<HardwarePage />} />
          {/* F3a: :revId here, or ?rev= on /files — first paint prefetches without /hardware. */}
          <Route path="files/revisions/:revId" element={<HardwarePage />} />
          <Route path="hardware" element={<ProjectLegacyRedirect to="files" />} />
          <Route path="hardware/revisions/:revId" element={<ProjectLegacyRedirect to="files/revisions" param="revId" />} />
          <Route path="issues" element={<IssuesPage />} />
          <Route path="issues/:issueId" element={<IssuesPage />} />
          <Route path="changes" element={<ReviewsPage />} />
          <Route path="changes/:reviewId" element={<ReviewsPage />} />
          <Route path="reviews" element={<ProjectLegacyRedirect to="changes" />} />
          <Route path="reviews/:reviewId" element={<ProjectLegacyRedirect to="changes" param="reviewId" />} />
          <Route path="agents" element={<AgentsPage />} />
          <Route path="mind" element={<ProjectLegacyRedirect to="agents" />} />
          <Route path="requirements" element={<RequirementsPage />} />
          <Route path="requirements/:reqId" element={<RequirementsPage />} />
          <Route path="milestones" element={<MilestonesPage />} />
          <Route path="releases" element={<MilestonesPage />} />
          <Route path="jobs" element={<JobsPage />} />
          <Route path="jobs/:jobId" element={<JobsPage />} />
          <Route path="settings/:tab?" element={<SettingsPage />} />
          <Route path="help/mcp" element={<McpPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}
